import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import api from '../../../services/api';

const PricingPreview = ({ isAdminPreview = true }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/pricing/');
      setPlans(res.data || []);
    } catch (err) {
      console.error('Error fetching pricing:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!plans.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#1e293b',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No pricing plans added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#1e293b', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Pricing
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${Math.min(plans.length, 3)}, 1fr)`,
        gap: '1rem'
      }}>
        {plans.slice(0, 3).map((plan, index) => (
          <div
            key={plan.id || index}
            style={{
              padding: '1rem',
              backgroundColor: plan.is_popular ? 'rgba(99, 102, 241, 0.1)' : 'rgba(255,255,255,0.05)',
              borderRadius: '0.75rem',
              border: plan.is_popular ? '2px solid #6366f1' : '1px solid rgba(255,255,255,0.1)',
              textAlign: 'center'
            }}
          >
            <h3 style={{ color: '#fff', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>
              {plan.name}
            </h3>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700' }}>
                ${plan.price}
              </span>
              {plan.period && (
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem' }}>
                  /{plan.period}
                </span>
              )}
            </div>
            {plan.features && (
              <div style={{ textAlign: 'left' }}>
                {(Array.isArray(plan.features) ? plan.features : plan.features.split('\n')).slice(0, 3).map((f, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', marginBottom: '0.25rem' }}>
                    <Check size={10} style={{ color: '#10b981' }} />
                    <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.65rem' }}>
                      {f.replace(/^[-+]\s*/, '')}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPreview;
